import { z } from 'zod';
import { QuerySpecSchema, DefinitionDraftSchema } from './metrics-catalog.js';
import { ProductAnalysisResultSchema, ProductAnalysisSpecSchema, } from './product-analysis.js';
export const AnalysisRangeSchema = z
    .object({
    from: z.iso.date(),
    to: z.iso.date(),
})
    .strict()
    .refine(({ from, to }) => {
    const limit = new Date(`${from}T00:00:00Z`);
    limit.setUTCFullYear(limit.getUTCFullYear() + 2);
    return from <= to && new Date(`${to}T00:00:00Z`) < limit;
}, '시작일부터 종료일까지 최대 24개월의 유효한 기간을 선택해 주세요');
export const CatalogAnalysisQuerySchema = z
    .object({
    type: z.literal('catalog'),
    spec: QuerySpecSchema.omit({ range: true }).strict(),
    range: AnalysisRangeSchema.optional(),
})
    .strict();
export const TemporaryAnalysisQuerySchema = z
    .object({
    type: z.literal('temporary'),
    definitions: z.array(DefinitionDraftSchema).min(1).max(8),
    spec: QuerySpecSchema.omit({ range: true }).strict(),
    range: AnalysisRangeSchema.optional(),
})
    .strict()
    .refine((query) => JSON.stringify(query.definitions).length <= 16000, '임시 조회 정의는 16,000자 이내로 작성해 주세요');
export const AnalysisQuerySchema = z.discriminatedUnion('type', [
    CatalogAnalysisQuerySchema,
    TemporaryAnalysisQuerySchema,
    z
        .object({
        type: z.literal('analysis'),
        spec: ProductAnalysisSpecSchema.omit({ range: true }),
        range: AnalysisRangeSchema.optional(),
    })
        .strict(),
]);
export const AnalysisPlanSchema = z
    .object({
    question: z.string().trim().min(1).max(2000),
    catalogVersion: z
        .string()
        .regex(/^[a-f0-9]{64}$/)
        .optional(),
    range: AnalysisRangeSchema.nullable(),
    queries: z.array(AnalysisQuerySchema).max(6),
    unsupported: z.array(z.string().min(1).max(500)).max(10),
})
    .strict();
export const AnalysisQueryResultSchema = ProductAnalysisResultSchema.omit({
    spec: true,
}).extend({
    range: AnalysisRangeSchema,
    // 직전 동일 길이 기간은 윤년 차이로 입력의 달력상 24개월보다 하루 길 수 있다.
    compareRange: z
        .object({ from: z.iso.date(), to: z.iso.date() })
        .strict()
        .optional(),
    compareRows: ProductAnalysisResultSchema.shape.rows.optional(),
});
export const AnalysisExecutionSchema = z.discriminatedUnion('status', [
    z.object({
        status: z.literal('fulfilled'),
        result: AnalysisQueryResultSchema,
    }),
    z.object({
        status: z.literal('failed'),
        label: z.string(),
        error: z.string(),
    }),
]);
//# sourceMappingURL=analysis-plan.js.map